module.exports = __webpack_public_path__ + "img/coupon.4d3cf15b.png";